<template>
    <teleport to="#modalTeleport">
    <ConfirmModal ref="confirmModal"></ConfirmModal>
  </teleport>
  <HeadlineComponent :subtitle="`Insgesamt: ${guests.length}`">Gäste</HeadlineComponent>
  <RouterLink :to="`/events/${$route.params.event}/guest/create`" class="btn btn-sm btn-primary mb-3" v-if="isAdmin">Neuer Gast</RouterLink>
  <input type="text" aria-label="Suche" placeholder="Suche" v-model="search" class="form-control mb-3">
  <template v-for="guest of searchResults" :key="guest.id">
    <div class="guest mb-4">
      <div>
        <span class="arrival-state" v-if="ticketing_enabled && !guest.ticket"><i class="fa-stack" style="font-size: 12.5px"><i class="fa fa-stack-1x fa-ticket"></i><i class="fa fa-ban fa-rotate-90 fa-stack-2x text-danger"></i></i></span>
        <a v-if="ticketing_enabled && isAdmin && guest.ticket && guest.ticket.has_arrived" @click.prevent="depart(guest)" href="#" class="arrival-state"><i class="fa fa-arrow-circle-down text-success"></i></a>
        <a v-if="ticketing_enabled && isAdmin && guest.ticket && !guest.ticket.has_arrived" @click.prevent="arrive(guest)" href="#" class="arrival-state"><i class="fa fa-arrow-circle-down text-danger"></i></a>
        <span class="arrival-state" v-if="ticketing_enabled && !isAdmin && guest.ticket"><i class="fa fa-arrow-circle-down" :class="{'text-success': guest.ticket.has_arrived, 'text-danger': !guest.ticket.has_arrived}"></i></span>
        <div class="contact-info">
          <template v-if="!isAdmin">
            {{guest.full_name}}
          </template>
          <RouterLink :to="`/events/${event_id}/guest/${guest.id}`" v-if="isAdmin">{{guest.full_name}}</RouterLink>
          <div class="mt-1">{{guest.group}}</div>
          <div class="">{{guest.email}}</div>
        </div>
      </div>
      <div class="system-info">
        {{guest.type.name}}<br />
        <template v-if="ticketing_enabled && guest.ticket">Ticket versendet: <i class="fa fa-ticket" :class="{'text-success': guest.ticket.ticket_sent, 'text-danger': !guest.ticket.ticket_sent}"></i></template><br />
        <LoadingButton :loading="guest.loading" @click="remove(guest);" class="btn-danger btn-sm mt-2" v-if="isAdmin">Löschen <i class="fa fa-remove"></i></LoadingButton>
      </div>
    </div>
    <hr class="mb-4 volunteer-hr"/>
  </template>

</template>

<script>
import {mapState, mapActions} from "pinia";
import {useUserStore} from "@/stores/user.js";
import { useConfigStore } from "@/stores/config";
import {useAlertsStore} from "@/stores/alerts.js";
import guestService from "@/services/guest.service.js";
import receptionService from "@/services/reception.service.js";
import HeadlineComponent from "@/components/HeadlineComponent.vue";
import LoadingButton from "@/components/LoadingButton.vue";
import ConfirmModal from "@/components/ConfirmModal.vue";
import * as Sentry from '@sentry/vue';

export default {
  name: "IndexGuestView",
  components: {LoadingButton, HeadlineComponent, ConfirmModal},
  data() {
    return {
      guests: [],
      search: "",
      event_id: ""
    }
  },
  async beforeRouteEnter(to, from, next) {
    let guests = []
    try {
      let response = await guestService.index(to.params.event)
      guests = response.data
    } catch (e) {
      if (e && e.response && e.response.data) {
        useAlertsStore().add('danger', e.response.data.message)
      } else {
        Sentry.captureException(e);
        useAlertsStore().add('danger', "Es ist was unerwartetes schief gegangen..");
        console.log(e)
      }
      window.scrollTo(0, 0);
    }
    next(vm =>{vm.guests = guests; vm.event_id = to.params.event});
  },
  methods: {
    ...mapActions(useAlertsStore, {addAlert: 'add'}),
    async remove(guest) {
      guest.loading = true;
      let text = `Möchtest du wirklich den Gast "${guest.full_name}" löschen?`
      console.log(guest)
      if(guest.ticket && guest.ticket.ticket_sent) {
        if(guest.ticket.user_id) {
          text += "<br /><b>Das Ticket wurde bereits verschickt</b>, wenn das zugehörige Crewmitglied nicht genug Schichten für die Veranstaltung hat, wird das Crewmitglied per Mail darüber informiert, dass das Ticket seine Gültigkeit verloren hat."
        } else {
          text += "<br /><b>Das Ticket wurde bereits verschickt</b>, der Gast wird eine Mail darüber erhalten, dass sein Ticket ungültig ist."
        }
      }
      if(await this.$refs.confirmModal.show("Gast Löschen", text)) {
      try {
        await guestService.remove(this.event_id, guest.id)
        for(let i=0; i<this.guests.length;i++) {
          if(this.guests[i].id === guest.id) {
            this.guests.splice(i, 1);
            break;
          }
        }
      } catch (e) {
        if (e) {
          Sentry.captureException(e);
          this.addAlert('danger', "Es ist was unerwartetes schief gegangen..");
          window.scrollTo(0, 0);
        }
      }
    }
      guest.loading = false;
    },
    async depart(guest) {
      try {
        await receptionService.depart(this.event_id, guest.ticket.id)
        guest.ticket.has_arrived = false
      } catch (e) {
        if (e) {
          Sentry.captureException(e);
          this.addAlert('danger', "Es ist was unerwartetes schief gegangen..");
          window.scrollTo(0, 0);
        }
      }
    },
    async arrive(guest) {
      try {
        await receptionService.arrive(this.event_id, guest.ticket.id)
        guest.ticket.has_arrived = true
      } catch (e) {
        if (e) {
          Sentry.captureException(e);
          this.addAlert('danger', "Es ist was unerwartetes schief gegangen..");
          window.scrollTo(0, 0);
        }
      }
    }
  },
  computed: {
    ...mapState(useUserStore, ['isAdmin']),
    ...mapState(useConfigStore, ['ticketing_enabled']),
    searchResults() {
      if(this.search) {
        var s = this.search.toLowerCase()
        return this.guests.filter(function(guest) {
          if(guest.full_name.toLowerCase().indexOf(s) >= 0 || 
             guest.group.toLowerCase().indexOf(s) >= 0 || 
             guest.email.toLowerCase().indexOf(s) >= 0 ||
             guest.type.name.toLowerCase().indexOf(s) >= 0) {
            return true
          }
          return false
        })
      } else {
        return this.guests
      }
    }
  }
}
</script>

<style scoped lang="scss">
.guest {
  justify-content: space-between;
  display: flex;

  .arrival-state {
    font-size: 25px;
    vertical-align: middle;
  }

  .contact-info {
    vertical-align: middle;
    display: inline-block;
    margin-left: 10px;
  }

  .system-info {
    text-align: right;
  }

}

.volunteer-hr {
  width: 90%;
  opacity: 0.2;
}

form {
  max-width: 330px;
  text-align: center;
  margin: 0 auto;
}

</style>